"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeBetweenStartAndEnd = exports.useClock = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _HitProvider = require("../provider/HitProvider");
var getTimeFromString = function getTimeFromString() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "0:0:0";
  var _time$split = time.split(":"),
    _time$split2 = (0, _slicedToArray2["default"])(_time$split, 3),
    hoursStr = _time$split2[0],
    minutesStr = _time$split2[1],
    secondsStr = _time$split2[2];
  return {
    hours: parseInt(hoursStr, 10),
    minutes: parseInt(minutesStr, 10),
    seconds: parseInt(secondsStr, 10)
  };
};
var timeBetweenStartAndEnd = function timeBetweenStartAndEnd(currentDate) {
  var _currentDate;
  currentDate = (_currentDate = currentDate) !== null && _currentDate !== void 0 ? _currentDate : new Date();
  var _getTimeFromString = getTimeFromString(global.__appConfig__.currentHitStartTime),
    hoursStart = _getTimeFromString.hours,
    minutesStart = _getTimeFromString.minutes,
    secondsStart = _getTimeFromString.seconds;
  var _getTimeFromString2 = getTimeFromString(global.__appConfig__.currentHitEndTime),
    hoursEnd = _getTimeFromString2.hours,
    minutesEnd = _getTimeFromString2.minutes,
    secondsEnd = _getTimeFromString2.seconds;
  var hours = currentDate.getHours();
  var minutes = currentDate.getMinutes();
  var seconds = currentDate.getSeconds();
  var timeEqualOrGraterFromStart = function timeEqualOrGraterFromStart() {
    if (hours > hoursStart) {
      return true;
    }
    if (hours === hoursStart && minutes > minutesStart) {
      return true;
    }
    if (hours === hoursStart && minutes === minutesStart && seconds >= secondsStart) {
      return true;
    }
    return false;
  };
  var timeEqualOrSmallerFromEnd = function timeEqualOrSmallerFromEnd() {
    if (hours < hoursEnd) {
      return true;
    }
    if (hours === hoursEnd && minutes < minutesEnd) {
      return true;
    }
    if (hours === hoursEnd && minutes === minutesEnd && seconds <= secondsEnd) {
      return true;
    }
    return false;
  };
  return {
    isTimeBetweenStartAndEnd: timeEqualOrSmallerFromEnd() && timeEqualOrGraterFromStart(),
    hoursStart: hoursStart,
    minutesStart: minutesStart,
    secondsStart: secondsStart,
    hoursEnd: hoursEnd,
    minutesEnd: minutesEnd,
    secondsEnd: secondsEnd
  };
};
exports.timeBetweenStartAndEnd = timeBetweenStartAndEnd;
var useClock = function useClock() {
  var _useHit = (0, _HitProvider.useHit)(),
    isActive = _useHit.isActive,
    setIsActive = _useHit.setIsActive;
  var _useState = (0, _react.useState)({
      hour: undefined,
      min: undefined,
      sec: undefined
    }),
    remainingTime = _useState[0],
    setRemainingTime = _useState[1];
  var isFirst = (0, _react.useRef)(false);
  var isWorking = (0, _react.useRef)(isActive);
  var getDate = function getDate() {
    var currentDate = new Date();
    var targetTime = new Date(currentDate);
    var _timeBetweenStartAndE = timeBetweenStartAndEnd(currentDate),
      isTimeBetweenStartAndEnd = _timeBetweenStartAndE.isTimeBetweenStartAndEnd,
      hoursStart = _timeBetweenStartAndE.hoursStart,
      minutesStart = _timeBetweenStartAndE.minutesStart,
      secondsStart = _timeBetweenStartAndE.secondsStart,
      hoursEnd = _timeBetweenStartAndE.hoursEnd,
      minutesEnd = _timeBetweenStartAndE.minutesEnd,
      secondsEnd = _timeBetweenStartAndE.secondsEnd;
    if (!isTimeBetweenStartAndEnd && isWorking.current) {
      setIsActive(false);
      isWorking.current = false;
    }
    if (isTimeBetweenStartAndEnd && !isWorking.current) {
      setIsActive(true);
      isWorking.current = true;
    }
    if (isWorking.current) {
      targetTime.setHours(hoursEnd, minutesEnd, secondsEnd, 0);
    } else {
      targetTime.setDate(targetTime.getDate() + 1);
      targetTime.setHours(hoursStart, minutesStart, secondsStart, 0);
    }
    var timeDifferenceMs = targetTime - currentDate;
    var hour = Math.floor(timeDifferenceMs / (1000 * 60 * 60));
    var min = Math.floor(timeDifferenceMs % (1000 * 60 * 60) / (1000 * 60));
    var sec = Math.floor(timeDifferenceMs % (1000 * 60) / 1000);
    if (hour < 0) {
      return {
        hour: 0,
        min: 0,
        sec: 0
      };
    }
    return {
      hour: hour,
      min: min,
      sec: sec
    };
  };
  (0, _react.useEffect)(function () {
    if (!isFirst.current) {
      setRemainingTime(function (prev) {
        return getDate();
      });
      isFirst.current = true;
    }
    var intervalId = setInterval(function () {
      setRemainingTime(function (prev) {
        return getDate();
      });
    }, 1000);
    return function () {
      clearInterval(intervalId);
    };
  }, []);
  return (remainingTime === null || remainingTime === void 0 ? void 0 : remainingTime.hour) === undefined ? remainingTime : addZeroToNumber(remainingTime);
};
exports.useClock = useClock;
var addZeroToNumber = function addZeroToNumber(values) {
  return Object.entries(values).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    acc[key] = String(value).padStart(2, "0");
    return acc;
  }, {});
};